import NudgeWarning from './NudgeWarning';

export default NudgeWarning;
